import type { ShiftRQSchema } from '@libs/data-access/queries'
import {
  analysisService,
  shiftService,
  userService
} from '@libs/data-access/queries'
import { Loader } from '@libs/ui/ds'
import type { FC } from 'react'
import React from 'react'

import { ShiftRealHoursForm, UnplannedShiftRealHoursForm } from '../../Forms'

import type { RealHoursModalProps } from './RealHoursModal'

export type RealHoursContainerProps = {
  modalData: RealHoursModalProps
  closeModal: () => void
}

export const RealHoursContainer: FC<RealHoursContainerProps> = ({
  modalData,
  closeModal
}) => {
  const currentUserQuery = userService.user.useFetchCurrentUser()

  const shiftQuery = shiftService.api.useFetchShift({
    pathParams: { id: modalData?.shiftId }
  })

  if (shiftQuery.isLoading || currentUserQuery.isLoading) {
    return <Loader.Overlay />
  }

  const isUnplanned = shiftQuery.data?.planification_type === 'unscheduled'

  return isUnplanned ? (
    <UnplannedShiftRealHoursForm
      shift={shiftQuery.data}
      formSuccess={() => {
        modalData.onSuccess?.()
        analysisService.invalidateFetch()
        closeModal()
      }}
      currentUserId={currentUserQuery?.data?.id ?? 0}
    />
  ) : (
    <ShiftRealHoursForm
      shift={shiftQuery.data ?? ({} as ShiftRQSchema)}
      formSuccess={() => {
        modalData.onSuccess?.()
        analysisService.invalidateFetch()
        closeModal()
      }}
      setDidNotShow={modalData.setDidNotShow}
      currentUserId={currentUserQuery?.data?.id ?? 0}
      precomputedCanValidate={modalData.precomputedCanValidate}
    />
  )
}
